import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { SmartQcComponent } from './smart-qc.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SummaryComponent } from './summary/summary.component';
import { CampaignComponent } from './campaign/campaign.component';

import { ChartModule } from 'angular2-highcharts';
import { ComponentsModule } from '../../../../components/component.module';
import { TooltipModule } from 'ngx-bootstrap';
import { ConfirmDialogModule, GrowlModule } from 'primeng/primeng';
import { ToastrModule } from 'ngx-toastr';
import { CardModule } from '../../../../layout/card';
import { CampaignDetailComponent } from './campaign/campaign-detail/campaign-detail.component';
import { CampaignCallDetailComponent } from './campaign/call-detail/campaign-call-detail.component';
import { SettingCategoryComponent } from './setting/category/setting-category.component';
import { SettingKeywordComponent } from './setting/keyword/setting-keyword.component';
import { SettingCriteriaComponent } from './setting/criteria/setting-criteria.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    GrowlModule,
    BrowserModule,
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot(),
    Select2Module,
    CardModule,
    ChartModule,
    ComponentsModule,
    TooltipModule,
  ],
  declarations: [
    SmartQcComponent,
    SummaryComponent,
    CampaignComponent,
    CampaignDetailComponent,
    CampaignCallDetailComponent,
    SettingCategoryComponent,
    SettingKeywordComponent,
    SettingCriteriaComponent,
  ],
  exports: [SmartQcComponent],
  providers: [],
})
export class SmartQcModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/smart-qc.module.ts